import {CanActivateFn, Router} from '@angular/router';

import { inject } from '@angular/core';
import {AuthStateService} from "../states/auth-state.service";

export const loginGuard: CanActivateFn = (route, state) => {
  const userService = inject(AuthStateService);
  const router = inject(Router);

  if (userService.isLoggedIn()) {
    // Ya autenticado: al área que corresponda según su rol.
    router.navigateByUrl(userService.landingRoute());
    return false;
  }
  return true;
};
